<template>
  <div>
    <div :class="{ mapContainer: mapLoaded, 'mb-2': isModal, 'mb-5': !isModal }" class="mb-2">
      <GoogleMap :zoom="15" :center="center" @map-loaded="setMapLoaded">
        <div v-if="mapLoaded">
          <GoogleMapMarker
            v-if="mapLoaded && vendor"
            :icon="{
              url: markerIconPath,
              size: new google.maps.Size(50, 60),
              scaledSize: new google.maps.Size(50, 60),
            }"
            :title="vendor.name"
            :google="google"
            :map="map"
            :position="center"
            :clickable="true"
          />
          <GoogleMapMarker
            v-for="(parkingSpace, index) in parkingSpaces"
            :key="`parkingSpaceMarker-${parkingSpace.name}`"
            :title="parkingSpace.name"
            :icon="parkingMarker"
            :label="createMarkerLabel(index + 1)"
            :google="google"
            :map="map"
            :position="{ lat: parkingSpace.lat, lng: parkingSpace.lng }"
            :clickable="true"
          />
        </div>
      </GoogleMap>
    </div>
    <div :class="isModal ? 'text-left' : 'container mb-5'">
      <div class="row">
        <div :class="isModal ? 'col-md-24' : 'col-md-11'">
          <div v-if="vendor" class="mb-2">
            <p class="h6 bold mb-0 text-muted font-weight-normal">{{ t.near }}</p>
            <a @click.prevent="panMap(vendor)" class="cursor-pointer">{{ vendor.address }}</a>
          </div>
          <slot></slot>
        </div>
        <div :class="isModal ? 'col-md-24' : 'col-md-12 offset-md-1'">
          <ParkingSpaceList
            :clickHandler="panMap"
            :distancePoint="vendor"
            :city-zone-id="cityZoneId"
            :t="t"
            :limit="listOpen ? undefined : listLimit"
            class="mb-2"
          />
        </div>
        <div v-if="isModal" class="col-md-24 text-center">
          <button @click="toggleList" class="btn btn-block btn-secondary-link btm-sm">
            {{ listOpen ? t.hide_list : t.show_list }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import ParkingSpaceList from "./ParkingSpaceList";
import GoogleMap from "./GoogleMap";
import GoogleMapMarker from "./GoogleMapMarker";
import { PARKING_MARKER_ICON_CONFIG, PARKING_MARKER_LABEL_CONFIG } from "./GoogleMapSettings";

export default {
  name: "ParkingSpaceView",
  components: { ParkingSpaceList, GoogleMap, GoogleMapMarker },
  props: {
    cityZoneId: {
      type: String,
      required: true,
    },
    center: {
      type: Object,
      required: true,
    },
    vendor: {
      type: Object,
      required: false,
      default: undefined,
    },
    t: {
      type: Object,
      required: true,
    },
    markerIconPath: {
      type: String,
      required: true,
    },
    isModal: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      listLimit: this.isModal ? 3 : undefined,
      listOpen: false,
      mapLoaded: false,
      google: null,
      map: null,
      parkingMarker: PARKING_MARKER_ICON_CONFIG,
    };
  },
  computed: {
    ...mapGetters({
      spacesDistance: "parkingSpaces/parkingSpacesDistance",
      spaces: "parkingSpaces/parkingSpaces",
    }),
    parkingSpaces() {
      return this.vendor ? this.spacesDistance(this.vendor) : this.spaces;
    },
  },
  methods: {
    panMap(parkingSpace) {
      this.map.panTo({ lat: parkingSpace.lat, lng: parkingSpace.lng });
    },
    createMarkerLabel(num) {
      return {
        ...PARKING_MARKER_LABEL_CONFIG,
        text: num.toString(),
      };
    },
    setMapLoaded({ map, google }) {
      this.google = google;
      this.map = map;
      this.mapLoaded = true;
    },
    toggleList() {
      this.listOpen = !this.listOpen;
    },
  },
};
</script>

<style lang="scss" scoped>
.mapContainer {
  height: 390px;
}
</style>
